<template>
    <v-layout row>
        <v-flex pa-2 xs12 sm6 offset-sm3>
            <v-card flat>
                <v-card-title class="indigo">
                    <span class="white--text">{{ title }}</span>
                </v-card-title>
                <v-list two-line>

                    <template v-for="item in produtos" >
                        <v-list-tile
                            ripple
                            :key="'list-' +item.id_produto"
                        >

                            <v-list-tile-content>
                                <v-list-tile-sub-title class="text--primary">{{ item.nome }}</v-list-tile-sub-title>
                                <v-list-tile-sub-title>QTDE: {{ item.qtde }}</v-list-tile-sub-title>
                            </v-list-tile-content>

                        </v-list-tile>
                        <v-divider :key="'divider-' + item.id_produto"/>
                    </template>

                </v-list>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "list-produtos",
        props: {
            title: {
                default: "PRODUTOS"
            },
            produtos: {
                default: []
            }
        }
    };
</script>

<style scoped>

</style>
